/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_CtaInputs */

const en_visa_o1_cta = /** @type {(inputs: Visa_O1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assess your O-1 qualifications`)
};

const pt_visa_o1_cta = /** @type {(inputs: Visa_O1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avalie suas qualificações O-1`)
};

const es_visa_o1_cta = /** @type {(inputs: Visa_O1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evalúe sus calificaciones O-1`)
};

/**
* | output |
* | --- |
* | "Assess your O-1 qualifications" |
*
* @param {Visa_O1_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_cta = /** @type {((inputs?: Visa_O1_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_cta(inputs)
	if (locale === "es") return es_visa_o1_cta(inputs)
	return en_visa_o1_cta(inputs)
});